webpackJsonp([117696030705815],{

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AC750.14fd0f76.png";

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CM-modules.70aeb0f1.png";

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ME381.3a4b0da1.png";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT174.f06c1137.png";

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT880.4e2238c0.png";

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/P2LPC.053820ac.png";

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SEP.91d1f2dc.jpg";

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(35);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _components = __webpack_require__(22);
	
	var _rectangleStyles = __webpack_require__(16);
	
	var _productInfo = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Programi = function Programi() {
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'products-title-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _components.Title,
	          { rectangleStyle: _rectangleStyles.greenRectangleStyle },
	          'Programi'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'products-accordion' },
	      _react2.default.createElement(_components.ProductList, { products: _productInfo.programi })
	    )
	  );
	};
	
	exports.default = Programi;
	module.exports = exports['default'];

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.programi = exports.oprema = exports.brojila = undefined;
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _MT = __webpack_require__(55);
	
	var _MT2 = _interopRequireDefault(_MT);
	
	var _ME = __webpack_require__(54);
	
	var _ME2 = _interopRequireDefault(_ME);
	
	var _AM = __webpack_require__(76);
	
	var _AM2 = _interopRequireDefault(_AM);
	
	var _MT3 = __webpack_require__(56);
	
	var _MT4 = _interopRequireDefault(_MT3);
	
	var _P2LPC = __webpack_require__(57);
	
	var _P2LPC2 = _interopRequireDefault(_P2LPC);
	
	var _AC = __webpack_require__(52);
	
	var _AC2 = _interopRequireDefault(_AC);
	
	var _SEP = __webpack_require__(58);
	
	var _SEP2 = _interopRequireDefault(_SEP);
	
	var _Sonda_ = __webpack_require__(59);
	
	var _Sonda_2 = _interopRequireDefault(_Sonda_);
	
	var _CMModules = __webpack_require__(53);
	
	var _CMModules2 = _interopRequireDefault(_CMModules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mt174pdf = (0, _gatsbyLink.withPrefix)('MT174_HRV.pdf');
	var mx381pdf = (0, _gatsbyLink.withPrefix)('Mx381_HRV.pdf');
	var mx382pdf = (0, _gatsbyLink.withPrefix)('Mx382_HRV.pdf');
	var am550pdf = (0, _gatsbyLink.withPrefix)('AM550_HRV.pdf');
	var mt880mpdf = (0, _gatsbyLink.withPrefix)('MT880_M_HRV.pdf');
	var p2lpcpdf = (0, _gatsbyLink.withPrefix)('P2LPC_HRV.pdf');
	var ac750pdf = (0, _gatsbyLink.withPrefix)('AC750_HRV.pdf');
	
	var brojila = exports.brojila = [{
	  title: 'MT174',
	  subtitle: 'Savršena kombinacija visoke funkcionalnosti i ekonomske održivosti',
	  text: 'Višefazni MT174 ima RS komunikacijsko sučelje koje omogućuje automatsko očitavanje brojila i priprema brojilo za korištenje u AMI sustavima. Opsežne funkcije koje onemogućavaju neovlašteno manipuliranje brojilom pružaju maksimalnu sigurnost za mjernih podataka. Visoko kvalitetan proizvodni proces omogućuje brojilu rad u stambenim i malim komercijalnim okruženjima.',
	  image: _MT2.default,
	  pdfs: [{
	    link: mt174pdf,
	    title: 'MT174.pdf'
	  }]
	}, {
	  title: 'Mx38y',
	  subtitle: 'Interoperabilno pametno brojilo s opsežnim funkcionalnim sposobnostima',
	  text: 'Generacija pametnih brojila s IDIS interoperabilnošću pravo je rješenje protiv ulaganja u loša brojila. Mx38y pametno brojilo djeluje kao komunikacijski pristupnik za interakciju i prikupljanje podataka s drugih energetskih uređaja (plin, voda, grijanje) i može se prilagoditi i nadograditi za buduće poslovne modele (putem specifičnih softverskih aplikacija). Suvremene metode šifriranja i provjere autentičnosti jamče maksimalnu sigurnost za vrijedne mjerne podatke.',
	  image: _ME2.default,
	  pdfs: [{
	    link: mx381pdf,
	    title: 'Mx381.pdf'
	  }, {
	    link: mx382pdf,
	    title: 'Mx382.pdf'
	  }]
	}, {
	  title: 'AM550',
	  subtitle: 'Modularno brojilo „Spremno za korištenje u pametnoj mreži"',
	  text: 'Pametno brojilo nove generacije s inovativnim platformskim pristupom, omogućuje besprijekornu integraciju funkcija pametnog brojila u pametnu mrežu. Univerzalno, standardizirano, transparentno sučelje za programiranje aplikacija unutar brojila olakšava jednostavnu razmjenu različitih komunikacijskih modula - to daje korisnicima potrebnu fleksibilnost za buduće poslovne modele. PLC komunikacijski moduli su kompatibilni s ranijim verzijama i time omogućuju, na primjer, jednostavno prebacivanje sa G1 na G3 komunikacijsku tehnologiju. Specifične korisničke aplikacije za „Smart Grid“ značajka su nove razine sposobnosti prilagođavanja brojila.',
	  image: _AM2.default,
	  pdfs: [{
	    link: am550pdf,
	    title: 'AM550.pdf'
	  }],
	  additionalInfo: {
	    title: 'Komunikacijski moduli',
	    items: [{
	      title: 'AC150-G3',
	      text: 'G3 komunikacijski modul'
	    }, {
	      title: 'AC150-A2',
	      text: 'Komunikacijski modul s GPRS sučeljem'
	    }, {
	      title: 'AC150-A5',
	      text: 'Komunikacijski modul s GPRS / LTE sučeljem'
	    }]
	  }
	}, {
	  title: 'MT880',
	  subtitle: 'Modularno precizno brojilo sa sveobuhvatnim kompletom funkcionalnosti',
	  text: 'Ovaj uređaj, koji je pogodan za velike i srednje velike komercijalne i industrijske aplikacije, u potpunosti obuhvaća zahtjeve tržišta pametne mreže i distribuiranog trenda proizvodnje. Praćenje kvalitete napajanja, bežična SCADA povezivost, modularnost komunikacije i brojni sigurnosni mehanizmi samo su neki od atributa koji jamče da je vaše ulaganje sigurno i dugoročno.',
	  image: _MT4.default,
	  pdfs: [{
	    link: mt880mpdf,
	    title: 'MT880_M.pdf'
	  }],
	  additionalInfo: {
	    title: 'Komunikacijski moduli',
	    items: [{
	      title: 'CM-v-3',
	      text: '2G modem s RS485 komunikacijskim sučeljem'
	    }, {
	      title: 'CM-u-3',
	      text: '3G modem s RS485 komunikacijskim sučeljem'
	    }, {
	      title: 'CM-e-3',
	      text: 'Ethernet modem s RS485 komunikacijskim sučeljem'
	    }, {
	      title: 'CM-f3e',
	      text: 'MODBUS modem preko TCP/IP i RTU'
	    }, {
	      title: 'CM-1-3',
	      text: 'Komunikacijski modul s CS i RS485 komunikacijskim sučeljima'
	    }],
	    images: [{ source: _CMModules2.default }]
	  }
	}];
	
	var oprema = exports.oprema = [{
	  title: 'P2LPC',
	  subtitle: 'Koncentrator podataka visoke učinkovitosti za upravljanje zajedničkim PLC brojilima',
	  text: 'Iskraemeco P2LPC podatkovni koncentrator je uređaj koji se dokazao u primjeni i koji omogućuje pouzdanu dvosmjernu komunikaciju s pametnim brojilima putem električnih vodova, upravlja mrežom i osigurava besprijekornu povezanost sa sustavom centra. Njegove napredne značajke čine ga idealnim za korištenje brojila u malim i velikim građevinskim kompleksima.',
	  image: _P2LPC2.default,
	  pdfs: [{
	    link: p2lpcpdf,
	    title: 'P2LPC.pdf'
	  }]
	}, {
	  title: 'AC750',
	  subtitle: 'Inovativna platforma s najsuvremenijim modularnim hardverom i softverom',
	  text: 'AC750 G3-PLC gateway / podatkovni koncentrator je ulaganje u budućnost integracije u pametnu mrežu. Ovaj komunikacijski uređaj temelji se na inovativnoj platformi koja povezuje sustav centra/Head-End-System s brojilima električne energije. Optimizira komunikacijski promet na vašoj mreži i učinkovito prenosi mjerne podatke i obavijesti o mreži. AC750 podržava širok raspon komunikacijskih sučelja i protokola, a opremljen je komunikacijskim modulima za zamjenu polja.',
	  image: _AC2.default,
	  pdfs: [{
	    link: ac750pdf,
	    title: 'AC750.pdf'
	  }]
	}, {
	  title: 'Sonda 5',
	  text: 'Sonda 5 s RS232 konektorom (brzina prijenosa do 57600 Bauda), te s USB konektorom (brzina prijenosa do 115200 Bauda). Služe za programiranje i očitanje podataka iz brojila i registratora putem optičkog sučelja sukladno s normom IEC 62056-21.',
	  image: _Sonda_2.default
	}];
	
	var programi = exports.programi = [{
	  title: 'Programska rješenja',
	  subtitle: 'SEP2W sustav',
	  text: 'Na svim razinama potrošnje, prijenosa i generacije energije univerzalni Iskraemeco AMM-sustav (Automated Meter Management) omogućava prikupljanje, pohranjivanje i obradu podataka o protoku električne energije kao i drugih energenata (toplinska energija, plin, voda itd.). Modularna struktura omogućava uporabu različitih mjernih i komunikacijskih naprava. U sustavu su mogući različit komunikacijski putevi (izravno povezivanje preko sučelja RS232, RS485 ili CS te modemske veze DLC, PSTN, ISDN, GSM/GPRS/UMTS/EDGE, ethernet itd.) kao i različiti protokoli (DLMS, IEC 62056-21, IEC 60870-5-102, FTP, NTP, SNMP, SOAP). Za korisnika lako razumljiv sofver omogućava jednostavno zahvatanje i obradu podataka, praćenje događanja kao i upravljanje električnom mrežom.',
	  image: _SEP2.default,
	  pdfs: []
	}];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-proizvodi-programi-js-ed486d22304ba27e11f0.js